import { render } from "./AddAddress.vue?vue&type=template&id=0e5e02a1&scoped=true"
import script from "./AddAddress.vue?vue&type=script&lang=ts"
export * from "./AddAddress.vue?vue&type=script&lang=ts"

import "./AddAddress.vue?vue&type=style&index=0&id=0e5e02a1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e5e02a1"

export default script